export default __webpack_public_path__ + "static/imgSSM7-b8f9fe8d466721029b2da9eaacbb4a6b.png";